export default {
    light: '#5bdce7',
    main: '#0EBDC8',
    dark: '#007a85',
    contrastText: '#fff'
};
